import { GoalTypeEnum } from "../enums/goal-type.enum";
import { Action, ActionModel } from "./action.model";
import { GoalText, GoalTextModel } from "./goaltext.model";
import { GroupGoal, GroupGoalModel } from "./group-goal.model";
import { Kpi } from "./kpi.model";

export interface Goal {
    id: number;

    questionId?: number;
    questionName: string;

    goalTextId?: number;
    name: string;   // Localized version of the goal text

    actions: Action[];      // For Text Based Goals
    kpiList: Kpi[];         // For Numeric Goals

    groupGoalId?: number;
    goalPeriodId?: number;
    groupGoal: GroupGoal;       // selected group goal

    targetValue?: number;

    goalType: GoalTypeEnum;
    result?: number;
    weight?: number;
}

export class GoalModel implements Goal {
    id = 0;
    
    questionId = null;
    questionName: string;
    
    goalTextId = null;
    name: string;                   // Localized version of the goal text

    actions: Action[] = [];         // For Text Based Goals
    kpiList: Kpi[] = [];            // For Numeric Goals

    groupGoalId = null;
    groupGoal: GroupGoal = null;
    goalPeriodId = null;
  
    targetValue = null;

    goalType: GoalTypeEnum;
    result?: number = null;
    weight?: number = null;
}

export interface InsertGoal extends Goal {
    reviewPeriodId: number;
    employeeId: number;
}